var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-upload-dragger',{attrs:{"before-upload":_vm.beforeUpload,"disabled":_vm.disabled,"fileList":_vm.fileList,"multiple":true,"name":"file"},on:{"change":_vm.uploadChange}},[_c('p',{staticClass:"ant-upload-text"},[_vm._v("点击或拖拽文件到当前区域，上传文件")]),_c('p',{staticClass:"ant-upload-hint"},[_vm._v(" 支持单个上传公司资料文件或其他文件 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }